import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";
import Handlebars from "handlebars";

export const _ConfirmPay = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.PAY_FEES;
  return callApi(url, "post", searchData && searchData);
};

export const _CheckOpenPaymentStudentNo = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.CHECK_OPEN_PAYMENT_STUDENT_NO;
  return callApi(url, "post", searchData && searchData);
};

export const _OpenPaymentFees = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.OPEN_PAYMENT_FEES;
  return callApi(url, "post", searchData && searchData);
};

export const _OpenPayment = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.OPEN_PAYMENT_LINk;
  return callApi(url, "post", searchData && searchData);
};

export const _ClassWisePendingFees = async (searchData = false) => {
  let url = ServiceUrl.MOB.CLASS_PENDING_FEES;
  return callApi(url, "post", searchData && searchData);
};

export const gethandelBars = () => {
  const helpers = {
    formatDate: function (date, format) {
      return moment(date).format(format);
    },
    ifEqual: function (value1, value2, options) {
      if (value1 === value2) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    },
  };

  for (const [name, helper] of Object.entries(helpers)) {
    Handlebars.registerHelper(name, helper);
  }

  // Return the registered helpers
  return Handlebars;
};
